"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinimalReport = exports.FullReport = exports.FullReportShare = exports.ReportCreator = exports.ReportResult = exports.ReportGenerationStatus = void 0;
var cerealParse_1 = require("../cerealParse");
var ReportGenerationStatus;
(function (ReportGenerationStatus) {
    ReportGenerationStatus[ReportGenerationStatus["done"] = 0] = "done";
    ReportGenerationStatus[ReportGenerationStatus["wip"] = 1] = "wip";
})(ReportGenerationStatus || (exports.ReportGenerationStatus = ReportGenerationStatus = {}));
var ReportResult = /** @class */ (function () {
    function ReportResult(reportId, status) {
        this.reportId = reportId;
        this.status = status;
    }
    ReportResult.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ReportResult(cerealParse_1.ParseUtils.getString(o, 'reportId'), cerealParse_1.ParseUtils.getEnum(o, 'status', ReportGenerationStatus)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ReportResult Model: ".concat(e.message));
        }
    };
    return ReportResult;
}());
exports.ReportResult = ReportResult;
var ReportCreator = /** @class */ (function () {
    function ReportCreator(id, name) {
        this.id = id;
        this.name = name;
    }
    ReportCreator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ReportCreator(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Report Creator: ".concat(e.message));
        }
    };
    return ReportCreator;
}());
exports.ReportCreator = ReportCreator;
var FullReportShare = /** @class */ (function () {
    function FullReportShare(id, count, creationTs, expirationTs, url, viewCount, format, timeZone, dateFormat, creator) {
        this.id = id;
        this.count = count;
        this.creationTs = creationTs;
        this.expirationTs = expirationTs;
        this.url = url;
        this.viewCount = viewCount;
        this.format = format;
        this.timeZone = timeZone;
        this.dateFormat = dateFormat;
        this.creator = creator;
    }
    FullReportShare.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullReportShare(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getNumber(o, 'count'), cerealParse_1.ParseUtils.getISODate(o, 'creationTs'), cerealParse_1.ParseUtils.getISODate(o, 'expirationTs'), cerealParse_1.ParseUtils.getString(o, 'url'), cerealParse_1.ParseUtils.getNumber(o, 'viewCount'), cerealParse_1.ParseUtils.getString(o, 'format'), cerealParse_1.ParseUtils.getString(o, 'timeZone'), cerealParse_1.ParseUtils.getString(o, 'dateFormat'), cerealParse_1.ParseUtils.getSubobject(o, 'creator', ReportCreator.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Full Report Share: ".concat(e.message));
        }
    };
    return FullReportShare;
}());
exports.FullReportShare = FullReportShare;
var FullReport = /** @class */ (function () {
    function FullReport(id, name, startTs, endTs, type, creator, share) {
        this.id = id;
        this.name = name;
        this.startTs = startTs;
        this.endTs = endTs;
        this.type = type;
        this.creator = creator;
        this.share = share;
    }
    FullReport.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullReport(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getISODate(o, 'startTs'), cerealParse_1.ParseUtils.getISODate(o, 'endTs'), cerealParse_1.ParseUtils.getString(o, 'type'), cerealParse_1.ParseUtils.getSubobject(o, 'creator', ReportCreator.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'share', FullReportShare.parse, 'ignore')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Full Report: ".concat(e.message));
        }
    };
    return FullReport;
}());
exports.FullReport = FullReport;
var MinimalReport = /** @class */ (function () {
    function MinimalReport(id, name, startTs, endTs, type, creator) {
        this.id = id;
        this.name = name;
        this.startTs = startTs;
        this.endTs = endTs;
        this.type = type;
        this.creator = creator;
    }
    MinimalReport.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalReport(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'startTs'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'endTs'), cerealParse_1.ParseUtils.getString(o, 'type'), cerealParse_1.ParseUtils.getSubobject(o, 'creator', ReportCreator.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Minimal Report Creator: ".concat(e.message));
        }
    };
    return MinimalReport;
}());
exports.MinimalReport = MinimalReport;
//# sourceMappingURL=report.js.map